import { useQuery } from 'react-query';
import apiClient from '../apiClient';
import { ShiftData } from '../types/TymbeApi';

export const useShift = (shiftId?: string | number) => {
  const queryKey = ['shift', 'application', Number(shiftId)] as const;

  return useQuery<ShiftData>(
    queryKey,
    async ({ queryKey: key }) =>
      apiClient.service('shift').get(key[2], {
        query: {
          $eager:
            '[company, branchoffice.parent, shiftTemplate, perk, manShift.[activeApplication.[person.[personData, blockedCompany(notDeleted)]], perk], application(withDeleted).[person.[personData, blockedCompany(notDeleted)], attendance.confirmedBy, shift.company]]',
          $appendJuniorProp: true,
        },
      }),
    { enabled: !!shiftId }
  );
};
